import _flowRight from 'lodash/flowRight';
import _uniqueId from 'lodash/uniqueId';
import { normalize } from 'normalizr';
import { getPublicProfiles } from '@homeservices/api-kit/search/publicprofile';

import { PUBLIC_PROFILES_SCHEMA } from '@/store/modules/entities';
import { toSnakeCase } from '@/utils/to-snake-case';
import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchPublicProfiles';

const emptyArray = [];

const initialPartialState = {
  status: REQUEST_LIFECYCLE.UNINITIALIZED,
  error: null,
  result: emptyArray,
  count: 0,
  total: 0,
  hasMore: false,
};

export default {
  namespaced: true,
  state: {
    publicProfileKey: _uniqueId(),
  },
  getters: {
    publicProfileKey: state => state.publicProfileKey,
    getPublicProfilesMetaByBucketName: state => (bucketName) => {
      const { result, ...meta } = state[bucketName] || initialPartialState;

      return meta;
    },
    getRawPublicProfilesByBucketName: state => bucketName =>
      (state[bucketName] || initialPartialState).result,
  },
  actions: {
    fetchPublicProfiles: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (context, { injected: { performFulfillment }, params = {} }) => {
        const {
          data: { results, total },
        } = await getPublicProfiles(toSnakeCase(params));
        const { result, entities } = normalize(results, [PUBLIC_PROFILES_SCHEMA]);

        return performFulfillment({
          total,
          result,
          entities,
        });
      }
    ),
    resetPublicProfiles: ({ commit }, { bucketName }) =>
      commit('resetPublicProfiles', { meta: { bucketName } }),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { bucketName } = payload.meta;
      const partialState = state[bucketName] || initialPartialState;
      const result = [
        ...new Set([...partialState.result, ...(payload.result || emptyArray)]),
      ];

      state[bucketName] = {
        ...partialState,
        ...payload,
        result,
        count: result.length,
        hasMore: result.length < payload.total,
      };

      state.publicProfileKey = _uniqueId();
    },
    resetPublicProfiles (state, { meta }) {
      const { bucketName } = meta;

      state[bucketName] = initialPartialState;
      state[bucketName].meta = meta;

      state.publicProfileKey = _uniqueId();
    },
  },
};
